export const CANONICAL_COLORS_EN = [
  'ORANGE',
  'WHITE',
  'BLUE',
  'YELLOW',
  'YE/GN',
  'GRAY',
  'RED',
  'BROWN',
  'BLACK',
  'GREEN',
  'PURPLE',
  'PINK'
];

export const COLOR_DISPLAY_LABELS = {
  en: {
    ORANGE: 'Orange',
    WHITE: 'White',
    BLUE: 'Blue',
    YELLOW: 'Yellow',
    'YE/GN': 'Yellow/Green',
    GRAY: 'Gray',
    RED: 'Red',
    BROWN: 'Brown',
    BLACK: 'Black',
    GREEN: 'Green',
    PURPLE: 'Purple',
    PINK: 'Pink'
  },
  it: {
    ORANGE: 'Arancio',
    WHITE: 'Bianco',
    BLUE: 'Blu',
    YELLOW: 'Giallo',
    'YE/GN': 'Giallo/Verde',
    GRAY: 'Grigio',
    RED: 'Rosso',
    BROWN: 'Marrone',
    BLACK: 'Nero',
    GREEN: 'Verde',
    PURPLE: 'Viola',
    PINK: 'Rosa'
  }
};

const createColorAliasesToEn = () => {
  const aliases = {};

  CANONICAL_COLORS_EN.forEach((color) => {
    aliases[color] = color;
  });

  Object.values(COLOR_DISPLAY_LABELS).forEach((languageLabels) => {
    Object.entries(languageLabels).forEach(([canonicalColor, label]) => {
      aliases[String(label).trim().toUpperCase()] = canonicalColor;
    });
  });

  // Explicit legacy aliases that differ from display labels or use shorthand notation.
  aliases['GI/VE'] = 'YE/GN';
  aliases['YE/GN'] = 'YE/GN';

  return aliases;
};

// Import aliases are derived from localized labels, so adding a new language usually only
// requires extending COLOR_DISPLAY_LABELS.
export const COLOR_ALIASES_TO_EN = createColorAliasesToEn();

export const COLOR_MAP = {
  ORANGE: '#FF6B35',
  WHITE: '#FFFFFF',
  BLUE: '#2196F3',
  YELLOW: '#FFD600',
  'YE/GN': null,
  GRAY: '#808080',
  RED: '#F44336',
  BROWN: '#8B4513',
  BLACK: '#000000',
  GREEN: '#4CAF50',
  PURPLE: '#9C27B0',
  PINK: '#E91E63',

  // Legacy aliases kept for visual compatibility during the transition.
  ARANCIO: '#FF6B35',
  BIANCO: '#FFFFFF',
  BLU: '#2196F3',
  GIALLO: '#FFD600',
  'GI/VE': null,
  GRIGIO: '#808080',
  ROSSO: '#F44336',
  MARRONE: '#8B4513',
  NERO: '#000000',
  VERDE: '#4CAF50',
  VIOLA: '#9C27B0',
  ROSA: '#E91E63'
};

// Exposed for compatibility with existing settings payloads; values are canonical EN.
export const COLORI_MAPPINGS = Object.fromEntries(
  Object.keys(COLOR_DISPLAY_LABELS).map((language) => [language, [...CANONICAL_COLORS_EN]])
);

// Costanti per i colori dei terminali
export const TERMINAL_COLORS = {
  PST: '#30D5C8', PSW: '#FFFFFF', PSG: '#BFBFBF', PSR: '#FF0000', PSN: '#000000',
  PSB: '#2196F3', PSG4: '#BFBFBF', PSY: '#FFFF00', PSR10: '#FF0000', PSB16: '#2196F3',
  PDW: '#FFFFFF', PDG: '#BFBFBF', PDR: '#FF0000', PDN: '#000000',
  PDB: '#2196F3', PDG4: '#BFBFBF', PDY: '#FFFF00', PDR10: '#FF0000',
  FRx: '#FF0000', FBx: '#2196F3', FYx: '#FFFF00',
  ORx: '#FF0000', OBx: '#2196F3', OYx: '#FFFF00',
  MLM: '#CECECE', MLF: '#CECECE',
  TR: '#FF0000', TB: '#2196F3', TY: '#FFFF00',
  'FSR2.8': '#FF0000', 'FSR4.8': '#FF0000', 'FSR6.3': '#FF0000', 'FS6.3': '#FF0000',
  'FCR2.8': '#FF0000', 'FCR4.8': '#FF0000', 'FCR6.3': '#FF0000', 'FC6.3': '#FF0000', 'FCB2.8': '#2196F3', 'FCB4.8': '#2196F3', 'FCB6.3': '#2196F3', FAS: '#FF0000'
};
